﻿enum ReservationBlockType {
	Undefined,
	OnStreet,
	OffStreet
}

export default ReservationBlockType;
